import { UserTableData } from "../../models/tables";
import { Table } from "../utils";

export class UserTable extends Table {
    searchTable(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        const searchText = inputElement.value;
        if (searchText !== "") {
          this.tableData = this.tableData?.filter((item: UserTableData) =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
          );
        } else this.tableData = this.constantTableData;
      }
}

export class InviteToSendTable extends Table {

  pageSize: number = 8;

}

export type Role = 'admin' | 'member';
type InviteStatus = 'pending' | 'accepted' | 'cancelled';

export interface InviteCreateRequest {
  invitee_email: string;
  invitee_role: Role;
}

export interface Invite {
  id: number;
  invitee_email: string;
  invitee_role: Role;
  inviter_user: string;
  expire_at: Date;
  status: InviteStatus;
  sent_at: Date;
}
